import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueMasonry from 'vue-masonry-css'
import VueGeolocation from 'vue-browser-geolocation';
import * as VueGoogleMaps from 'vue2-google-maps';
import moment from "moment-jalaali";
import VuePreferences, {preference} from 'vue-preferences';
import VueSocialSharing from 'vue-social-sharing';
import VueMeta from 'vue-meta';
import goTo from 'vuetify/lib/services/goto'
import VueObserveVisibility from 'vue-observe-visibility'




import "@/assets/styles/fontawesome.min.css";
import "@/assets/styles/vuetify.css";
import "@/assets/styles/bootstrap.min.css";
import "@/assets/styles/all.min.css";
import "@/assets/styles/master.css";

Vue.config.productionTip = false;

Vue.use(VuePreferences, {
    storage: window.localStorage,
    namespace: 'ivankhane'
});
Vue.use(VueSocialSharing);
Vue.use(VueMeta);
Vue.use(VueObserveVisibility)

Vue.prototype.$baseUrl = 'https://pwa.eyvankhaneh.app/'
Vue.use(VueMasonry);
Vue.prototype.$setUserData = function (mobile, activeCode, token, role) {
    preference('userData', {defaultValue: '{"mobile":"", "activeCode":"","token":"","role":""}'})
        .set(JSON.stringify({'mobile': mobile, 'activeCode': activeCode, 'token': token, 'role': role}));
};

// Vue.prototype.$setShowSplash = function (value) {
//     preference('appState', {defaultValue: ""}).set(value);
// };
// Vue.prototype.$getShowSplash = function () {
//     return JSON.parse(preference('splash',
//         {defaultValue: '{"isShow":false}'}).get());
// };
Vue.prototype.$getUserData = function () {
    return JSON.parse(preference('userData',
        {defaultValue: '{"mobile":"", "activeCode":"","token":"","role":""}'}).get());
};
Vue.prototype.$setAppState = function (value) {
    preference('appState', {defaultValue: ""}).set(value);
};
Vue.prototype.$getAppState = function () {
    return preference('appState', {defaultValue: ""}).get();
};
Vue.prototype.$replaceHttps = function (httpUrl) {
    if (httpUrl !== null && httpUrl !== undefined) {
        return httpUrl.replace("http://", "https://");
    }
};
Vue.prototype.$computingPriceOffer = function (price, off) {
    let priceNum = price;
    if (price !== null && price !== undefined) {
        if (typeof priceNum !== "number") {
            priceNum = price.replace(",", "");
        }
        return this.$numberWithCommas(parseInt(priceNum) - (parseInt(priceNum) * (off / 100)));
    }
};
Vue.prototype.$numberWithCommas = function (x) {
    if (x !== null && x !== undefined) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
};
Vue.prototype.$getImageUrl = function (pic) {
    if (pic !== undefined) {
        return require("./assets/img/" + pic);
    }
}
Vue.prototype.$openLink = function (url) {
    /*var newWindow = window.open("about:blank", "_blank");
    newWindow.location = url;*/
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    // a.download = <your_fileName>;
    a.click();
    document.body.removeChild(a);
}
Vue.prototype.$roundNum = function (num) {
    if (num) {
        return Number(num.toFixed(1))
    } else {
        return num
    }
}
Vue.prototype.$convertDate = function (date) {
    if (date !== undefined && date !== null) {
        let sliceDate = date.slice(0, 10)
        return moment(sliceDate).format('jYYYY/jMM/jDD')
    }
}
Vue.prototype.$TypeInvoiceStatus = function (type) {
    switch (type) {
        case 1:
            return 'ثبت سفارش'
        case 2:
            return 'تایید سفارش'
        case 3:
            return 'تحویل سفارش'
        case 4:
            return 'لغو سفارش'
    }
}
Vue.prototype.$TypePayment = function (type) {
    switch (type) {
        case 1:
            return 'آنلاین'
        case 2:
            return 'کارت به کارت'
        case 3:
            return 'در محل'
        case 4:
            return 'از کیف پول'
        case 5:
            return 'بدون پرداختی'
        case 6:
            return 'آپلود رسید واریز'
    }
}
Vue.prototype.$convertDateToMiladi = function (day) {
    return moment(day, 'jYYYY/jMM/jDD').format('YYYY-MM-DD')
}
Vue.prototype.$dayOfWeek = function (date) {
    return moment(date).day()
}
Vue.prototype.$TypeVehicleSend = function (type) {
    switch (type) {
        case 1:
            return 'بر عهده فروشنده'
        case 2:
            return 'پیک موتوری'
        case 3:
            return 'وانت سبک'
        case 4:
            return 'وانت سنگین'
        case 5:
            return 'ایسوزو'
        case 6:
            return 'خاور معمولی'
        case 7:
            return 'خاور بزرگ'
        case 8:
            return 'کامیون معمولی'
        case 9:
            return 'کامیون تک'
        case 10:
            return 'کامیون جفت'
    }
}
Vue.prototype.$TypeDiscount = function (type) {
    switch (type) {
        case 1:
            return 'عمومی'
        case 2:
            return 'دنبال_کنندگان'
        case 3:
            return ' دنبال_کننده_خاص'
    }
}
Vue.prototype.$TypeVendorProductStatus = function (type) {
    switch (type) {
        case 1:
            return 'تازه ثبت شده'
        case 2:
            return 'در انتظار بررسی'
        case 3:
            return 'تایید شده'
        case 4:
            return 'رد شده'
    }
}
Vue.prototype.$convertFarsiNumber = function (number) {
    if (/([۰-۹])/g.test(number)) {
        return number.replace(/([۰-۹])/g, token => String.fromCharCode(token.charCodeAt(0) - 1728))
    }else {
        return number
    }
}

Vue.use(VueGeolocation)

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBqLXDV8HIaaA2ATo8cFm99FMI75WYFNSg',
        libraries: "places",
        language: "fa"
    }
})
Vue.prototype.$scrollTop = function (x) {
    return goTo(x);
}


new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");
